// This file exists to abstract the chartist.js usage
const KadChartist = () => {
  return {
    init: (node, params) => {
      new KadChartist.Chart(node, params);
    }
  };

} // End Kadenze.Chartist

KadChartist.Chart = function(node, params) {
  this.defaults = {
    userData: params.data,
    node: node,
    $node: $(node),
    type: 'bar',
    truncateLabels: false,
    showTooltips: true,
    showGraphGrid: true,
    paginatePer: 0,
    showPercentageLabels: false, // Currently this only makes sense with Pie charts
    responsiveOptions: [],
    chartistOptions: {
      showArea: false,
      onlyInteger: true,
      lineSmooth: Chartist.Interpolation.none(),
      axisX: {
        offset: 15
      },
      axisY: {
        offset: 15
      },
      chartPadding: {
        top: 15,
        right: 15,
        bottom: 15,
        left: 15
      }
    }
  };

  this.tooltipContextMapping = {
    'bar'   : '.ct-bar',
    'line'  : '.ct-point',
    'pie'   : '.ct-slice-pie, .ct-slice-donut',
    'donut' : '.ct-slice-donut'
  };

  this.chartistTypeMapping = {
    'line' : 'Line',
    'donut': 'Pie',
    'pie'  : 'Pie',
    'bar'  : 'Bar'
  };

  this.config = _.extend({}, this.defaults, params);

  this.init = () => {
    this.modifyDefaultOptions();
    this.buildChart();
    this.delegateEvents();
  };

  this.buildChart = () => {
    this.chart = new Chartist[this.chartistTypeMapping[this.config.type]](
      this.config.node,
      this.cachedData || this.config.data,
      this.config.chartistOptions,
      this.config.responsiveOptions
    );
  };

  this.delegateEvents = () => {
    if(!this.config.showGraphGrid) {
      this.chart.on('draw', this.removeHorizontalGrid);
    }

    if(this.config.showTooltips) {
      this.buildTooltips();
    }

    if(this.config.paginatePer > 0) {
      this.initPagination();
    }

    if(this.config.truncateLabels) {
      this.config.userData.labels = this.truncatedLabels()
    }
  };

  this.modifyDefaultOptions = () => {

    // Setting default options for donut charts
    if(this.config.type === 'donut') {
      this.config = _.extend(this.config, {
        showPercentageLabels: true,
        chartistOptions: {
          donut: true,
          labelOffset: 22,
          labelPosition: 'outside',
          labelDirection: 'explode'
        }
      });
    }

    if(this.config.showPercentageLabels) {
      this.config.chartistOptions.labelInterpolationFnc = this.percentageLabelInterpolation;
    }
  };

  this.initPagination = () => {
    this.labelsPaginator = new Paginate(this.config.data.labels, this.config.paginatePer);

    this.seriesPaginators = this.config.data.series.map(series => {
      return new Paginate(series.data, this.config.paginatePer)
    });

    // Trigger initial pagination
    this.nextPage();
  };

  this.nextPage = () => {
    this.chart.update(this.getPaginatedData('next'));
    this.setPageIndicators();
  };

  this.prevPage = () => {
    this.chart.update(this.getPaginatedData('prev'));
    this.setPageIndicators();
  };

  this.getPaginatedData = direction => {
    return {
      labels: this.labelsPaginator[direction](),
      series: this.seriesPaginators.map((pager, index) => {
        return { data: pager[direction](), name: this.config.data.series[index].name };
      })
    };
  };

  this.setPageIndicators = () => {
    this.isLastPage = !this.labelsPaginator.hasNext();
    this.isFirstPage = !this.labelsPaginator.hasPrev();
  };

  this.removeHorizontalGrid = data => {
    if (data.type === 'grid' && data.index !== 0)
      data.element.remove();
  };

  this.buildTooltips = () => {
    const $tip = this.config.$node.append($('<div/>', { class: 'tooltip' })).find('.tooltip').hide();

    this.config.$node.on('mouseenter', this.tooltipContextMapping[this.config.type], { $tip: $tip }, this.appendTooltip);
    this.config.$node.on('mousemove', { $tip: $tip }, this.moveTooltip);
    this.config.$node.on('mouseleave', this.tooltipContextMapping[this.config.type], () => {
      $tip.hide();
    });
  };

  this.appendTooltip = event => {
    const $point = $(event.target),
      $parent = $point.parent(),
      value = $point.attr('ct:value'),
      seriesName = $parent.attr('ct:series-name') || $parent.find('.ct-label').text();

    event.data.$tip.html(seriesName + '<br/>' + value).show();
  };

  this.moveTooltip = (event) => {
    event.data.$tip.css({
      left: (event.offsetX || event.originalEvent.layerX) - event.data.$tip.width() / 2 - 10,
      top: (event.offsetY || event.originalEvent.layerY) - event.data.$tip.height() - 40
    });
  };

  this.percentageLabelInterpolation = (label, index) => {
    const series = this.config.data.series[index],
      total = _.pluck(this.config.data.series, 'value').reduce((a, b) => a + b),
      percentage = series.value / total * 100;

    return series.name + ': ' + series.value + ' (' + percentage.toFixed(1) + '%)';
  };

  this.truncatedLabels = () => {
    return this.config.userData.labels.map(value => {
      if (value.length > 15) {
        return `${value.substring(0, 15)}...`
      } else {
        return value
      }
    })
  }

  (() => this.init())()

}; // End Kadenze.Chartist.Chart

export default KadChartist;
